/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'player_play': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.99 0C15.515-.002 19.997 4.475 20 10c-.003 5.525-4.485 10.002-10.01 10C4.471 19.994 0 15.519 0 10S4.471.006 9.99 0zM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM7.578 6.303l5.916 3.764-5.916 3.765V6.303z" _fill="#D9D9D9" fill-rule="evenodd"/>'
  }
})
